import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";

import { checkSearchObject } from "app/common/LocalFunction";
import { ConceptSymptom } from "app/common/Model/ConceptSymptom";
import {
  deleteConceptSymptom,
  getconceptSymptomId,
  pagingconceptSymptom,
  saveconceptSymptom,
} from "app/services/ConceptSymptomService";
import { toast } from "react-toastify";
import { getAllHealthCareService } from "app/services/HealthCareService";

export default class ConceptSymptomStore {
  searchConceptSymptom = new SearchObject();
  pageConceptSymptom = null;
  selectedConceptSymptom = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteConceptSymptom = false;
  listHealthCareService = [];

  constructor() {
    makeAutoObservable(this);
  }

  pagingConceptSymptom = async (searchObj) => {
    let newSearchObj = { ...this.searchConceptSymptom, ...searchObj };
    return await pagingconceptSymptom(newSearchObj)
      .then(({ data }) => {
        this.pageConceptSymptom = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleChangeFormSearch = (searchConceptSymptom) => {
    this.searchConceptSymptom = checkSearchObject(
      this.searchConceptSymptom,
      searchConceptSymptom
    );
    this.pagingConceptSymptom();
  };

  handleOpenFormCreateOrEdit = (ConceptSymptomId) => {
    // getAllHealthCareService().then(({ data }) => {
    //   this.listHealthCareService = data;
    // });
    if (Boolean(ConceptSymptomId)) {
      getconceptSymptomId(ConceptSymptomId)
        .then(({ data }) => {
          this.selectedConceptSymptom = data;
          this.openFormCreateOrEdit = true;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    } else {
      this.selectedConceptSymptom = new ConceptSymptom();
      this.openFormCreateOrEdit = true;
    }
  };

  saveConceptSymptom = async (ConceptSymptom, { setSubmitting }) => {
    return await saveconceptSymptom(ConceptSymptom)
      .then(() => {
        this.selectedConceptSymptom = null;
        toast.success("Lưu mẫu kết quả thành công!");
        this.handleClosePopup();
        this.pagingConceptSymptom();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin mẫu kết quả có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleDeleteConceptSymptom = (ConceptSymptom) => {
    this.selectedConceptSymptom = { id: ConceptSymptom?.id };
    this.openConfirmDeleteConceptSymptom = true;
  };

  handleConfirmDeleteConceptSymptom = () => {
    return deleteConceptSymptom(this?.selectedConceptSymptom?.id)
      .then(() => {
        if (
          this.searchConceptSymptom.pageIndex > 1 &&
          this.pageConceptSymptom?.content?.length === 1
        ) {
          this.searchConceptSymptom.pageIndex -= 1;
        }
        toast.success("Xóa mẫu kết quả thành công!");
        this.handleClosePopup();
        this.pagingConceptSymptom();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Xóa mẫu kết quả có lỗi");
      });
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteConceptSymptom = false;
  };

  resetStore = () => {
    this.searchConceptSymptom = new SearchObject()
    this.pageConceptSymptom = null;
    this.selectedConceptSymptom = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteConceptSymptom = false;
  };
}
